import Intercom from '@intercom/messenger-js-sdk';

const APP_ID = 'wbp68du6';

export function bootIntercom(user: {
  userId: string;
  email: string;
  name?: string;
  plan?: string;
  createdAt?: number; // unix timestamp
  jwtToken?: string;
}) {
  Intercom({
    app_id: APP_ID,
    user_id: user.userId,
    email: user.email,
    name: user.name,
    created_at: user.createdAt,
    // Custom attributes
    plan: user.plan,
    ...(user.jwtToken ? { intercom_user_jwt: user.jwtToken } : {}),
  });
}

export function updateIntercom(data?: Record<string, unknown>) {
  (window as any).Intercom?.('update', data ?? {});
}

export function shutdownIntercom() {
  (window as any).Intercom?.('shutdown');
}

export function bootIntercomAnonymous() {
  Intercom({ app_id: APP_ID });
}
